var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('scroll-indicator'),_c('Navbar'),_c('main-bar',[_c('home'),_c('store'),_c('features'),_c('about'),_c('services'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }